module.exports = __webpack_public_path__ + "img/iskrobezopasnyj-instrument.72a054dc.svg";